import React, { useState } from "react";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { Select } from "./Select";
import InputInlineDropdown from "../atoms/InputInlineDropdown";
import { TextArea } from "../atoms/TextArea";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { PlusIcon } from "@heroicons/react/20/solid";
import { t } from "i18next";

type Errors = { nombre: string };
type LeadFormAddListProps = {
  handleSubmit: () => void;
  setToggleNewLeadModal: (open: boolean) => void;
  toggleNewLeadModal: boolean;
  formData: {
    nombre: string;
    date: string;
    correo: string;
    beneficios: string;
    time: string;
    men_utilization: number[];
    women_utilization: number[];
  };
  errors: Errors;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedOptionBranch: string;
  setSelectedOptionBranch: (option: string) => void;
  optionsBranch: string[];
  OnOpenAddProduct: () => void;
};

const LeadFormAddList: React.FC<LeadFormAddListProps> = ({
  handleSubmit,
  setToggleNewLeadModal,
  toggleNewLeadModal,
  formData,
  errors,
  handleChange,
  OnOpenAddProduct,
}) => {

  const [rooms, setRooms] = useState([
    { local: "Sala 1" },
  ]);

  return (
    <DialogCreate
      OnclickCreate={handleSubmit}
      OnclickCancel={() => {
        setToggleNewLeadModal(false);
      }}
      tittleButtonCreate="Crear"
      tittleButtonCancel="Cancelar"
      open={toggleNewLeadModal}
      setOpen={setToggleNewLeadModal}
      tittle={"Añadir datos"}
      subTittle={""}
    >
      <div className="mt-6 mx-2">
        <div className="space-y-12">
          <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10  pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    
                  </h2>
                </div>
              </div>
            </div>
            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
              <div className="col-span-full flex space-x-4">
                <div className="flex-1">
                  <InputWithCornerHint
                    label="Fecha"
                    span="Obligatorio"
                    id="date"
                    name="date"
                    type="date"
                    placeholder="nombre"
                    value={formData.date}
                    onChange={handleChange}
                    error={errors.nombre}
                  />
                </div>
                <div className="flex-1">
                  <InputWithCornerHint
                    label="Hora"
                    span="Obligatorio"
                    id="time"
                    name="time"
                    type="time"
                    placeholder="nombre"
                    value={formData.time}
                    onChange={handleChange}
                    error={errors.nombre}
                  />
                </div>
              </div>

              <div className="col-span-full flex space-x-4">
                <table className="min-w-full divide-y divide-gray-300 col-span-6">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        {t("user.views.occupation_lesson_room")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("user.views.occupation_lesson_men")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("user.views.occupation_lesson_women")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {formData.men_utilization.map((room, index) => (
                      <tr key={index} className="gap-6">
                        <td className="text-center py-4 px-2">
                          <InputWithCornerHint
                            label=""
                            span=""
                            id={`men_utilization_${index}`}
                            name={`men_utilization[${index}]`}
                            type="number"
                            placeholder=""
                            value={formData.men_utilization[index]}
                            onChange={handleChange}
                            error={false}
                          />
                        </td>
                        <td className="text-center py-4 px-2">
                          <InputWithCornerHint
                            label=""
                            span=""
                            id={`men_utilization_${index}`}
                            name="men_utilization[]"
                            type="number"
                            placeholder=""
                            value={0}
                            onChange={handleChange}
                            error={false}
                          />
                        </td>
                        <td className="text-center py-4 px-2">
                          <InputWithCornerHint
                            label=""
                            span=""
                            id={`women_utilization_${index}`}
                            name="women_utilization[]"
                            type="number"
                            placeholder=""
                            value={0}
                            onChange={handleChange}
                            error={false}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="col-span-full flex space-x-4 border-t-2">
                <div className="flex-1"></div>
                <button
                  onClick={OnOpenAddProduct}
                  type="button"
                  className="mt-3 block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
                  aria-label="Add"
                >
                  <PlusIcon
                    aria-hidden="true"
                    className="h-5 w-5"
                  />
                </button>
                <div className="flex-1"></div>
              </div>

              {/*
              <div className="col-span-full">
                <Select
                  selected={selectedOptionBranch}
                  setSelected={setSelectedOptionBranch}
                  options={optionsBranch}
                  tittle="Sexo"
                />
              </div>
              <div className="col-span-full">
                <InputWithCornerHint
                  label="Fecha de nacimiento"
                  span="DD/MM/YYYY"
                  id="date"
                  name="date"
                  type="date"
                  placeholder="Enter date"
                  error={false}
                  onChange={handleChange}
                  value={formData.date}
                />
              </div>
              <div className="col-span-full">
                <InputWithCornerHint
                  label="Correo"
                  span="Obligatorio"
                  id="correo"
                  name="correo"
                  type="text"
                  placeholder="correo"
                  value={formData.nombre}
                  onChange={handleChange}
                  error={errors.nombre}
                />
              </div>
              <div className="col-span-full">
                <InputInlineDropdown
                  title="Número de Whatsapp / Movil (Incluye el prefijo de tu país) "
                  titleDropdown="Codigo Pais"
                  inputType="tel"
                  inputPlaceholder="Ingrese su numero de telefono"
                  dropdownOptions={["+1", "+44", "+91"]}
                  icon={faPhone}
                />
              </div>
              <div className="col-span-full">
                <TextArea
                  label="Comentarios"
                  span="Opcional"
                  id="Comentarios"
                  name="Comentarios"
                  value={formData.beneficios}
                  onChange={handleChange}
                />
              </div>
              */}

            </div>
          </div>
        </div>
      </div>
    </DialogCreate>
  );
};

export default LeadFormAddList;
